<div class="isp-social__delimiter">
  <span class="isp-social__delimiter__label">{{
    config.templateOptions.label
  }}</span>
</div>
<div class="icons" [innerHTML]="config.templateOptions.content"></div>
